import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1064.71853 308.989309L0 959.644691 1064.71853 1610.30007 1064.71853 1087.93691 1919.89309 1609.76552 1919.89309 309.52386 1064.71853 831.245559z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconRewindSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconRewindSolid, _Component);

  var _super = _createSuper(IconRewindSolid);

  function IconRewindSolid() {
    _classCallCheck(this, IconRewindSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconRewindSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRewind",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconRewindSolid.displayName = "IconRewindSolid";
  return IconRewindSolid;
}(Component);

IconRewindSolid.glyphName = 'rewind';
IconRewindSolid.variant = 'Solid';
IconRewindSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRewindSolid;
export { IconRewindSolid };